import { render } from "./QueryEventsBar.vue?vue&type=template&id=b0f452fc&scoped=true"
import script from "./QueryEventsBar.vue?vue&type=script&lang=js"
export * from "./QueryEventsBar.vue?vue&type=script&lang=js"

import "./QueryEventsBar.vue?vue&type=style&index=0&id=b0f452fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f452fc"]])

export default __exports__